import "./About.module.css";
import Header from "@/reusable_sections/Header";
import AboutHero from "./sections/AboutHero";
import OurStory from "./sections/OurStory";
import CompanyVideos from "./sections/CompanyVideos";
import VideoBlock from "./sections/VideoBlock";
import TwoColumnLayoutWithImage from "./sections/TwoColumnLayoutWithImage";
import TwoColumnImageText from "./sections/TwoColumnImageText";
import ImageWithTextBlock from "./sections/ImageWithTextBlock";
import ImageWithText from "./sections/ImageWithText";
import CardContainer from "./sections/CardContainer";
import DuplicatedImageWithTextBlock from "./sections/DuplicatedImageWithTextBlock";
import ImageAndTextSplit from "./sections/ImageAndTextSplit";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <AboutHero />
      <VideoBlock />
      <TwoColumnLayoutWithImage />
      <TwoColumnImageText />
      <OurStory />
      <CompanyVideos />
      <ImageWithTextBlock />
      <DuplicatedImageWithTextBlock />
      <ImageAndTextSplit />
      <ImageWithText />
      <CardContainer />
      <Footer />
    </div>;
}